import React from 'react';

export default function PanelDev() {

    return (
        <div className='w-full text-center overflow-hidden text-2xl mt-96'>In Development Mode</div>
    )

}